module.exports = __webpack_public_path__ + "img/watermark.37877b32.png";